// @ts-nocheck
import React from 'react'
import { useMediaQuery, useTheme } from '@mui/material';
export const AuctionListHeader = ({ properties, HandleAuction, auctionDetail, scroll, scrollContainerRef, auctionId }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      {/* <div className='pt-4 font-semibold text-xl text-darkGray'>Today's Auctions</div> */}

      <div className='flex w-full items-center mt-2 mb-2 gap-1'>
        {/* Left Slide Button */}
        {properties?.length > 0 &&
          <>
            {isMobile ? ("") :
              <div onClick={() => scroll('left')} className='cursor-pointer' aria-label="Scroll Left" role='button'>
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path></svg>
              </div>
            }


            <div className='scroll-container p-2 px-3' ref={scrollContainerRef} style={{ overflowX: isMobile ? "auto" : "none" }}>
              <div className='flex gap-1 '>
                {properties?.map((data, key) => {
                  return (
                    <div
                      key={key}
                      onClick={() => { if (data?.id != auctionId) HandleAuction(data?.id) }}
                      style={{
                        transform: data?.id == auctionId && "scale(1.05)"
                      }}
                      className={data?.id == auctionId
                        ? 'cursor-pointer text-sm xl:text-base pr-8 pl-8 font-semibold p-2 rounded-t-lg text-[#FF5C39]  transition-transform duration-200 ease-in-out bg-white border-t-[1px] border-r-[1px] border-b-0 border-l-[1px] border-solid border-[#D9D9D926] shadow-custom-shadow '
                        : 'cursor-pointer text-xs xl:text-sm pr-8 pl-8 font-medium p-2 border-2 rounded-t-lg text-[#3b3b3b]'}
                    >
                      {data.address}
                    </div>
                  )
                })}
              </div>
            </div>

            {/* Right Slide Button */}
            {isMobile ? ("") : <div onClick={() => scroll('right')} aria-label="Scroll Right" className='cursor-pointer float-right' role='button'>
              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z"></path></svg>
            </div>}
          </>

        }
      </div>
    </>
  )
}

